import { ErrorCode } from "@models/enums/error.codes";


export abstract class ErrorBase {
  abstract errorObject?: any;
  abstract date?: Date;
  abstract message: string;
  abstract errorCode: ErrorCode;
}
